'use client';

import type { Dispatch } from 'react';
import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { iaDatabaseInititalState } from './iaDatabase.constants';
import type { IADatabaseAction, IADatabaseContextReducerState, IaDatabaseManagementProviderProps } from './iaDatabase.types';
import { IaDatabaseActionTypesEnum } from './iaDatabase.types';
import { iaDatabaseReducer } from './reducers';

// Define the context
export const IaDatabaseManagementContext = createContext<{
  iaDatabase: IADatabaseContextReducerState;
  dispatch: Dispatch<IADatabaseAction>;
}>({
  iaDatabase: iaDatabaseInititalState,
  dispatch: () => null
});

// // Define the ValidationDetailsProvider component
export const IaDatabaseManagementProvider: React.FC<IaDatabaseManagementProviderProps> = ({
  children,
  iaDatabase
}) => {
  const [iaManagementDetails, dispatch] = useReducer(iaDatabaseReducer, iaDatabase);
  useEffect(() => {
    dispatch({
      type: IaDatabaseActionTypesEnum.updateIaDatabase,
      payload: iaDatabase
    });
  }, [iaDatabase]);
  return <IaDatabaseManagementContext.Provider value={{
    iaDatabase: iaManagementDetails,
    dispatch
  }} data-sentry-element="unknown" data-sentry-component="IaDatabaseManagementProvider" data-sentry-source-file="index.tsx">
      {children}
    </IaDatabaseManagementContext.Provider>;
};

// Define a custom hook to use the TabPanelState context
export const useIaDataBaseManagementContext = () => useContext(IaDatabaseManagementContext);

// selector for database entity
export const useIaDatabaseSelector: <T>(selector: (state: IADatabaseContextReducerState) => T) => T = selector => {
  const context = useIaDataBaseManagementContext();
  if (!context) {
    throw new Error('useSelector must be used within a StateProvider');
  }
  const {
    iaDatabase
  } = context;

  // Memoize the selected value
  return useMemo(() => selector(iaDatabase), [selector, iaDatabase]);
};